import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Processingcapacities } from '../../../components/Grossharvestofproducts/Processingcapacities'; 

const ProcessingcapacitiesPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Мощности переработки</title>
            </Helmet>
            <Processingcapacities/>
        
        </>
    );
};

export default ProcessingcapacitiesPage
